export default __webpack_public_path__ + "static/2458-33e4f5ea8a5ae4bdc192cac58e2fa1c9.gif";